// Observed Metadata.
import ObservedSVG from '../../../assets/images/Thoughts/Observed.svg';

const HappySadMetadata = {
  id: 'Observed',
  title: 'Can you see me?',
  description: 'The Weight of Being Watched',
  thumbnail: ObservedSVG,
  featured: false,
};

export default HappySadMetadata;
